import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const GetCustomers = (query) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}${query}`
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const GetCustomer = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomer = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}`,
    data: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetCustomerCoupon = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/set_coupon`,
    data: {
      coupon_id: data.coupon_id
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveCustomerCoupon = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${id}/remove_coupon`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerMailbox = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/account_number`,
    params: {
      customer: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerPhotoIdExpiration = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/update_photo_id_expires_on`,
    data: {
      customer: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCustomer = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.customers,
    params: {
      customer: data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCustomerLvl1 = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/enterprise`,
    params: {
      customer: data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ExportCustomersCSV = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.customers_csv,
    params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ImportCustomersCSV = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.accounts_import,
    data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AuthenticateCustomer = (id) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${id}/authenticate`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetRoles = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.roles
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetCustomerRole = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/account_role`,
    params: {
      customer: {
        role: data.role
      }
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const EnableCustomer = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/enable`,
    params: {
      customer: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CancelScheduledActivation = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/cancel_scheduled_activation`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const DisableCustomer = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/disable`,
  };

  if (data.expires_on)
    requestOptions.params = {
      expires_on: data.expires_on
    }

  if (data.end_of_period)
    requestOptions.params = {
      end_of_period: data.end_of_period
    }

  return axios(requestOptions)
    .then(res => res.data);
}


export const CancelScheduledCancelation = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/stop_disabling`,
  };
  return axios(requestOptions)
    .then(res => res.data);
}


export const DeleteCustomer = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerActivities = (data) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${data.id}/account_activities`,
    params: data.page ? {page: data.page} : {}
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DestroyAccountDocument = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/account_documents/destroy`,
    data: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SaveAccountDocument = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/account_documents`,
    data: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetCustomerTrial = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/subscriptions/trial_end`,
    params: {
      subscription: {
        trial_end_date: data.date
      }
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveCustomerTrial = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${id}/subscriptions/trial_end`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCustomerCharge = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/charges`,
    data: {
      charge: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCustomCharge = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.customer_id}/invoices/${data.id}/custom_charges`,
    data: {
      charge: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteCustomCharge = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.customer_id}/invoices/${data.invoice_id}/custom_charges/${data.id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCustomInvoice = (id) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${id}/invoices`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteInvoice = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.customer_id}/invoices/${data.invoice_id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetLiveRecipients = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.receptionist_accounts
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddLiveRecipient = (params) => {
  const requestOptions = {
    method: 'POST',
    url: urls.receptionist_accounts,
    data: {
      additional_live_receptionist_account: params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateLiveRecipient = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.receptionist_accounts}/${data.id}`,
    data: {
      additional_live_receptionist_account: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteLiveRecipient = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.receptionist_accounts}/${id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetOfficerndMembers = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.officernd_members,
    params,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectOfficerndMember = (params) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.officernd_members}/connect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DisconnectOfficerndMember = (params) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.officernd_members}/disconnect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetDeskworksMembers = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.deskworks_members,
    params,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectDeskworksMember = (params) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.deskworks_members}/connect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DisconnectDeskworksMember = (params) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.deskworks_members}/disconnect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}


export const GetQuickbooksMembers = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.quickbooks_members,
    params,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectQuickbooksMember = (params) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.quickbooks_members}/connect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DisconnectQuickbooksMember = (params) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.quickbooks_members}/disconnect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetNexudusMembers = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.nexudus_members,
    params,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectNexudusMember = (params) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.nexudus_members}/connect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DisconnectNexudusMember = (params) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.nexudus_members}/disconnect`,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}
